/* Updated: 2026-06-18 03:00 UTC+1 — Hub contact form location pickers */

(function () {
  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function LocationPicker(container, opts) {
    this.container = container;
    this.kind = container.getAttribute('data-gohub-location-picker') || 'country';
    this.hiddenInput = container.querySelector('[data-gohub-location-value]');
    this.trigger = container.querySelector('[data-gohub-location-trigger]');
    this.triggerText = container.querySelector('[data-gohub-location-trigger-text]');
    this.panel = container.querySelector('[data-gohub-location-panel]');
    this.searchInput = container.querySelector('[data-gohub-location-search]');
    this.listEl = container.querySelector('[data-gohub-location-list]');
    this.placeholder = container.getAttribute('data-gohub-location-placeholder') || 'Select';
    this.emptyText = container.getAttribute('data-gohub-location-empty') || 'No matches';
    this.onChange = opts && opts.onChange ? opts.onChange : null;
    this.selectedValue = '';
    this.selectedLabel = '';
    this.isOpen = false;
    this.options = [];
    this.bind();
    this.renderTrigger();
  }

  LocationPicker.prototype.bind = function () {
    var self = this;
    if (!this.trigger || !this.panel || !this.searchInput || !this.listEl || !this.hiddenInput) return;

    this.trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (self.isOpen) self.close(); else self.open();
    });

    this.searchInput.addEventListener('input', function () {
      self.renderList(self.searchInput.value);
    });

    this.searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.close();
    });

    document.addEventListener('click', function (e) {
      if (!self.isOpen) return;
      if (!self.container.contains(e.target) && !self.panel.contains(e.target)) self.close();
    });
  };

  LocationPicker.prototype.open = function () {
    if (!this.options.length) return;
    this.isOpen = true;
    this.panel.hidden = false;
    this.panel.classList.add('is-open');
    this.trigger.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.appendChild(this.panel);
    this.positionPanel();
    this.searchInput.value = '';
    this.renderList('');
    var self = this;
    setTimeout(function () { self.searchInput.focus(); }, 30);
    this._reposition = function () { self.positionPanel(); };
    window.addEventListener('scroll', this._reposition, true);
    window.addEventListener('resize', this._reposition);
  };

  LocationPicker.prototype.positionPanel = function () {
    if (!this.trigger || !this.panel) return;
    var rect = this.trigger.getBoundingClientRect();
    this.panel.style.position = 'fixed';
    this.panel.style.top = (rect.bottom + 6) + 'px';
    this.panel.style.left = rect.left + 'px';
    this.panel.style.width = rect.width + 'px';
    this.panel.style.zIndex = '9999';
  };

  LocationPicker.prototype.close = function () {
    this.isOpen = false;
    this.panel.hidden = true;
    this.panel.classList.remove('is-open');
    this.trigger.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.container.appendChild(this.panel);
    if (this._reposition) {
      window.removeEventListener('scroll', this._reposition, true);
      window.removeEventListener('resize', this._reposition);
      this._reposition = null;
    }
  };

  LocationPicker.prototype.setOptions = function (options) {
    this.options = (options || []).slice();
    if (this.selectedValue && this.options.indexOf(this.selectedValue) === -1) {
      this.clear(false);
    }
    this.renderTrigger();
  };

  LocationPicker.prototype.renderTrigger = function () {
    if (!this.triggerText) return;
    if (this.selectedLabel) {
      this.triggerText.textContent = this.selectedLabel;
      this.triggerText.classList.remove('is-placeholder');
    } else {
      this.triggerText.textContent = this.placeholder;
      this.triggerText.classList.add('is-placeholder');
    }
    this.container.classList.toggle('has-value', !!this.selectedValue);
  };

  LocationPicker.prototype.renderList = function (filter) {
    var self = this;
    var query = String(filter || '').toLowerCase().trim();
    var filtered = this.options.filter(function (opt) {
      if (!query) return true;
      return String(opt).toLowerCase().indexOf(query) !== -1;
    });

    if (!filtered.length) {
      this.listEl.innerHTML = '<li class="gohub-location-picker__empty">' + esc(this.emptyText) + '</li>';
      return;
    }

    var html = '';
    filtered.forEach(function (opt) {
      var selectedCls = opt === self.selectedValue ? ' is-selected' : '';
      html += '<li><button type="button" class="gohub-location-picker__option' + selectedCls + '" data-value="' + esc(opt) + '">';
      if (self.kind === 'country') {
        var loc = window.GOHUB_CONTACT_LOCATION || {};
        var code = '';
        (loc.countries || []).forEach(function (country) {
          if (country.n === opt) code = country.c;
        });
        if (code && loc.flagUrl) {
          html += '<img class="gohub-location-picker__flag" src="' + esc(loc.flagUrl(code)) + '" alt="" width="20" height="20" loading="lazy" decoding="async">';
        }
      }
      html += '<span>' + esc(opt) + '</span></button></li>';
    });
    this.listEl.innerHTML = html;

    this.listEl.querySelectorAll('[data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.select(btn.getAttribute('data-value'));
      });
    });
  };

  LocationPicker.prototype.select = function (value, silent) {
    this.selectedValue = value || '';
    this.selectedLabel = this.selectedValue;
    if (this.kind === 'country') {
      var loc = window.GOHUB_CONTACT_LOCATION || {};
      var code = '';
      (loc.countries || []).forEach(function (country) {
        if (country.n === value) code = country.c;
      });
      this.hiddenInput.value = code || '';
      if (this.triggerText) {
        if (code && loc.flagUrl) {
          this.trigger.innerHTML = '';
          var img = document.createElement('img');
          img.className = 'gohub-location-picker__flag';
          img.src = loc.flagUrl(code);
          img.alt = '';
          img.width = 20;
          img.height = 20;
          img.loading = 'lazy';
          img.decoding = 'async';
          this.triggerText = document.createElement('span');
          this.triggerText.className = 'gohub-location-picker__trigger-text';
          this.triggerText.textContent = value;
          var chevron = document.createElement('span');
          chevron.className = 'gohub-location-picker__chevron';
          chevron.setAttribute('aria-hidden', 'true');
          chevron.textContent = '▾';
          this.trigger.appendChild(img);
          this.trigger.appendChild(this.triggerText);
          this.trigger.appendChild(chevron);
        } else {
          this.renderTrigger();
        }
      }
    } else {
      this.hiddenInput.value = this.selectedValue;
      this.renderTrigger();
    }
    this.container.classList.remove('is-invalid');
    this.close();
    if (!silent && this.onChange) this.onChange(this.selectedValue, this.hiddenInput.value);
  };

  LocationPicker.prototype.setValue = function (value, label) {
    if (!value) return;
    if (this.kind === 'country') {
      var loc = window.GOHUB_CONTACT_LOCATION || {};
      var name = label || loc.countryName(value);
      if (name && this.options.indexOf(name) !== -1) {
        this.select(name, true);
        this.hiddenInput.value = String(value).toUpperCase();
        return;
      }
    }
    if (this.options.indexOf(value) !== -1) {
      this.select(value, true);
    }
  };

  LocationPicker.prototype.clear = function (notify) {
    this.selectedValue = '';
    this.selectedLabel = '';
    this.hiddenInput.value = '';
    if (this.trigger) {
      this.trigger.innerHTML = '';
      this.triggerText = document.createElement('span');
      this.triggerText.className = 'gohub-location-picker__trigger-text is-placeholder';
      this.triggerText.setAttribute('data-gohub-location-trigger-text', '');
      this.triggerText.textContent = this.placeholder;
      var chevron = document.createElement('span');
      chevron.className = 'gohub-location-picker__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.textContent = '▾';
      this.trigger.appendChild(this.triggerText);
      this.trigger.appendChild(chevron);
    }
    this.renderTrigger();
    if (notify && this.onChange) this.onChange('', '');
  };

  LocationPicker.prototype.getCode = function () {
    return (this.hiddenInput && this.hiddenInput.value) || '';
  };

  LocationPicker.prototype.getLabel = function () {
    if (this.kind === 'country') return this.selectedLabel || '';
    return this.selectedValue || '';
  };

  LocationPicker.prototype.isValid = function () {
    return !!(this.hiddenInput && this.hiddenInput.value);
  };

  function LocationPickers(root, copy) {
    this.root = root;
    this.copy = copy || {};
    this.countryPicker = null;
    this.statePicker = null;
    this.cityPicker = null;
    this.init();
  }

  LocationPickers.prototype.init = function () {
    var countryEl = this.root.querySelector('[data-gohub-location-picker="country"]');
    var stateEl = this.root.querySelector('[data-gohub-location-picker="state"]');
    var cityEl = this.root.querySelector('[data-gohub-location-picker="city"]');
    if (!countryEl || !cityEl || !window.GOHUB_CONTACT_LOCATION) return;

    var loc = window.GOHUB_CONTACT_LOCATION;
    var countryNames = loc.countries.map(function (c) { return c.n; });
    var self = this;

    this.countryPicker = new LocationPicker(countryEl, {
      onChange: function () {
        self.refreshLayout();
        self.notifyChange();
      }
    });
    this.countryPicker.setOptions(countryNames);

    if (stateEl) {
      this.statePicker = new LocationPicker(stateEl, {
        onChange: function () {
          self.refreshCityOptions(true);
          self.notifyChange();
        }
      });
    }

    this.cityPicker = new LocationPicker(cityEl, {
      onChange: function () {
        self.notifyChange();
      }
    });
    this.refreshLayout(false);
  };

  LocationPickers.prototype.notifyChange = function () {
    if (this.root) {
      this.root.dispatchEvent(new CustomEvent('gohub-location-update', { bubbles: false }));
    }
  };

  LocationPickers.prototype.isUsSelected = function () {
    return this.countryPicker && this.countryPicker.getCode() === 'US';
  };

  LocationPickers.prototype.refreshLayout = function (clearValues) {
    if (!this.countryPicker || !this.cityPicker) return;
    var loc = window.GOHUB_CONTACT_LOCATION;
    var code = this.countryPicker.getCode();
    var isUs = code === 'US';
    var stateEl = this.root.querySelector('[data-gohub-location-picker="state"]');

    if (stateEl) {
      stateEl.hidden = !isUs;
    }

    if (clearValues !== false) {
      if (this.statePicker) this.statePicker.clear(false);
      this.cityPicker.clear(false);
    }

    if (isUs) {
      if (this.statePicker) {
        this.statePicker.setOptions(loc.statesForCountry('US'));
      }
      this.refreshCityOptions(false);
    } else {
      this.cityPicker.setOptions(code ? loc.citiesForCountry(code) : []);
    }
  };

  LocationPickers.prototype.refreshCityOptions = function (clearCity) {
    if (!this.cityPicker) return;
    var loc = window.GOHUB_CONTACT_LOCATION;
    var code = this.countryPicker ? this.countryPicker.getCode() : '';

    if (code === 'US') {
      var state = this.statePicker ? this.statePicker.getCode() : '';
      if (clearCity !== false) this.cityPicker.clear(false);
      this.cityPicker.setOptions(state ? loc.citiesForUsState(state) : []);
      return;
    }

    if (clearCity !== false) this.cityPicker.clear(false);
    this.cityPicker.setOptions(code ? loc.citiesForCountry(code) : []);
  };

  LocationPickers.prototype.prefillFromGeo = function (geo) {
    if (!geo || !this.countryPicker || !this.cityPicker) return;
    var loc = window.GOHUB_CONTACT_LOCATION;
    var countryCode = String(geo.country_code || '').toUpperCase();

    if (countryCode && !this.countryPicker.getCode()) {
      this.countryPicker.setValue(countryCode);
      this.refreshLayout(false);
    }

    if (countryCode === 'US' && this.statePicker && !this.statePicker.getCode()) {
      var stateMatch = loc.matchOptionValue(this.statePicker.options, geo.region || '');
      if (stateMatch) {
        this.statePicker.setValue(stateMatch);
        this.refreshCityOptions(false);
      }
    }

    if (!this.cityPicker.getCode()) {
      var cityQuery = loc.normalizeGeoCity(geo.city, geo.region, countryCode);
      var cityMatch = loc.matchOptionValue(this.cityPicker.options, cityQuery);
      if (cityMatch) this.cityPicker.setValue(cityMatch);
    }
  };

  LocationPickers.prototype.validate = function () {
    var ok = true;
    if (this.countryPicker) {
      this.countryPicker.container.classList.toggle('is-invalid', !this.countryPicker.isValid());
      if (!this.countryPicker.isValid()) ok = false;
    }
    if (this.isUsSelected() && this.statePicker) {
      this.statePicker.container.classList.toggle('is-invalid', !this.statePicker.isValid());
      if (!this.statePicker.isValid()) ok = false;
    }
    if (this.cityPicker) {
      this.cityPicker.container.classList.toggle('is-invalid', !this.cityPicker.isValid());
      if (!this.cityPicker.isValid()) ok = false;
    }
    return ok;
  };

  LocationPickers.prototype.getCountryCode = function () {
    return this.countryPicker ? this.countryPicker.getCode() : '';
  };

  LocationPickers.prototype.getCountryLabel = function () {
    return this.countryPicker ? this.countryPicker.getLabel() : '';
  };

  LocationPickers.prototype.getState = function () {
    return this.statePicker ? this.statePicker.getCode() : '';
  };

  LocationPickers.prototype.getCity = function () {
    return this.cityPicker ? this.cityPicker.getCode() : '';
  };

  window.GohubContactLocation = {
    init: function (root, copy) {
      return new LocationPickers(root, copy);
    }
  };
})();
